import { Card, Grid, IconButton, Radio } from '@mui/material';
import { Close } from '@mui/icons-material';
import { CSSProperties, ReactNode } from 'react';
import { useSearchResultBoxStyles } from './search-result-box.styles';

export function SearchResultBox({
  onSelect,
  isSelected,
  onClose,
  alignRadioButton,
  children
}: {
  isSelected: boolean;
  onSelect(): void;
  alignRadioButton: CSSProperties['alignItems'];
  children: ReactNode;
  onClose?(): void;
}) {
  const isOnClickShouldPropagate = typeof onClose === 'undefined';
  const cardOnClickHandler = isOnClickShouldPropagate ? () => onSelect() : undefined;
  const radioButtonOnClickHandler = isOnClickShouldPropagate ? undefined : () => onSelect();

  const classes = useSearchResultBoxStyles({ isOnClickShouldPropagate });

  function OnCloseButton() {
    // Ignore action handlers added by Storybook
    if (onClose && onClose.name !== 'actionHandler') {
      return (
        <IconButton className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      );
    } else {
      return null;
    }
  }
  return (
    <Card className={classes.card} variant="outlined" onClick={cardOnClickHandler}>
      <OnCloseButton />
      <Grid
        className={classes.grid}
        container
        direction="row"
        wrap="nowrap"
        sx={{
          alignItems: alignRadioButton
        }}
      >
        <Grid>
          <Radio classes={{ colorSecondary: classes.radio }} checked={isSelected} onClick={radioButtonOnClickHandler} />
        </Grid>
        <Grid className={classes.content}>
          <div>{children}</div>
        </Grid>
      </Grid>
    </Card>
  );
}
